(function () {
    'use strict';

    angular
        .module('iMatApp')
        .controller('PreviouslyUploadedModelsWindowController', PreviouslyUploadedModelsWindowController);

    PreviouslyUploadedModelsWindowController.$inject = ['$scope', '_', '$uibModalInstance', 'multiselect'];

    function PreviouslyUploadedModelsWindowController($scope, _, $uibModalInstance, multiselect) {
        var vm = this;
        vm.modelIDs = [];

        vm.toggleModel = toggleModel;
        vm.selectOneModelAndClose = selectOneModelAndClose;
        vm.isSelected = isSelected;
        vm.getSelectedItemsCount = getSelectedItemsCount;

        vm.close = close;
        vm.cancel = cancel;
        
        // ---------------------------------------------------------------------------------------------
        
        function toggleModel(model) {
            if ((isSelected(model)) === true) {
                forgetModel(model);
            } else {
                rememberModel(model);
            }
        }

        function selectOneModelAndClose(model) {
            vm.modelIDs = [];
            rememberModel(model);
            close();
        }

        function isSelected(model) {
            return _.some(vm.modelIDs, function (modelID) { return modelID === model.ModelId; });
        }

        function getSelectedItemsCount() {
            return vm.modelIDs.length;
        }

        function rememberModel(model) {
            if (!multiselect) {
                vm.modelIDs = [];
            }

            vm.modelIDs.push(model.ModelId);
        }

        function forgetModel(model) {
            vm.modelIDs = _.reject(vm.modelIDs, function (id) {
                return id === model.ModelId;
            });
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }

        function close() {
            $uibModalInstance.close(multiselect ? vm.modelIDs : vm.modelIDs[0]);
        }
    }
})();
